import { gql } from "@apollo/client";

export const GET_ORGS = gql`
query getOrgs {
  msgbox_Organisation(order_by: {Name: asc}) {
    Name
    OrganisationId
  }
}
`;

export const GET_INBOXES = gql`
query get_inboxes($org: Int) {
  msgbox_Inbox(where: {OrganisationId: {_eq: $org}}, order_by: {Name: asc}) {
    Name
    InboxId
    OrganisationId
    APIAccountId
  }
}
`

export const GET_TEMPLATE_CATEGORIES = gql`
query getTemplateCategories {
  msgbox_TemplateCategory(where: {IsEnabled: {_eq: true}}, order_by: {Name: asc}) {
    TemplateCategoryId
    Name
  }
}
`;

export const GET_TEMPLATE_TYPES = gql`
	query getTemplateTypes {
		msgbox_TemplateType {
			Description
			TemplateTypeId
		}
	}
`;

export const GET_TEMPLATE_LANGUAGES = gql`
	query GetTeplateLanguages {
		msgbox_TemplateLanguage(order_by: { Order: asc }) {
			LanguageCode
			Description
		}
	}
`;


export const EDIT_MSGBOX_TEMPLATE = gql`
mutation addTemplateMessage(
		$name: String!
		$messageText: String!
		$attachment: String!
		$category: Int!
		$templateType: Int!
		$account: Int!
		$exampleMessage: String!
		$attachmentId: Int
		$language: String!
		$buttonMetaData: String
  		$Id: Int
	) {
		update_msgbox_Template(
      where:{
        TemplateId: {_eq: $Id}
      }
			_set: {
				Name: $name
				TemplateText: $messageText
				TemplateCategoryId: $category
				Attachment: $attachment
				TemplateTypeId: $templateType
				APIAccount: $account
				TemplateExample: $exampleMessage
				AttachmentId: $attachmentId
				LanguageCode: $language
				ButtonMetadata: $buttonMetaData
        		Status: Pending
				RejectionReason: null
			}
		) {
			affected_rows
		}
	}
`